import DocumentLocalStepsModal from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal'
import { WizardData } from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal/types'
import { Folder } from 'modules/documents/hooks/useGetFolders'

interface Props {
  onClose: () => void
  onDeleteFile: (i: number) => void
  onDropFiles: (files: File[]) => void
  onUploadFinished: () => Promise<unknown>
  folders: Folder[]
  isReadOnly: boolean
}

const SameFileEveryoneStepsModal = ({
  onClose,
  onDeleteFile,
  onDropFiles,
  onUploadFinished,
  isReadOnly,
  folders,
}: Props) => {
  const initialData: WizardData = {
    distributionWorkflow: 'same_files',
    uploadType: 'do_not_touch',
    folderId: null,
    numberSplitPages: 1,
    esignatureRequest: false,
    additionalSignersAccessIds: [],
  }

  return (
    <DocumentLocalStepsModal
      onClose={onClose}
      onDeleteFile={onDeleteFile}
      onDropFiles={onDropFiles}
      onUploadFinished={onUploadFinished}
      isReadOnly={isReadOnly}
      folders={folders}
      wizardData={initialData}
    />
  )
}

export default SameFileEveryoneStepsModal
